import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '..';
import { bundlesAdapter } from './bundlesSlice';

const selectSelf = (state: RootState) => state.bundles;

export const bundleSelectors = bundlesAdapter.getSelectors(selectSelf);

export const selectBundlesLoading = createSelector(
  selectSelf,
  ({ isLoading }) => isLoading
);

export const selectBundleGenerating = createSelector(
  selectSelf,
  ({ isGenerating }) => isGenerating
);

export const selectAreAllLoaded = createSelector(
  selectSelf,
  ({ areAllLoaded }) => areAllLoaded
);

export const selectEarliestBundleId = createSelector(
  bundleSelectors.selectIds,
  (ids) => ids[ids.length - 1] ?? null
);
